import { IColors } from 'styled-components';

export class Colors implements IColors {
  // FOUNDATION
  primary = '#353760';
  secondary = '#377AC9';
  tertiary = '#C56BDA';
  error = '#EF4444';
  warning = '#F79000';
  success = '#15D06C';
  spruceDarkGreen = '#0A4A43';
  spruceDarkGreenHover = '#083A35';

  // CORE
  // Background
  defaultBackground = '#F6F7F6';
  secondarySelectedBackground = '#D1D5DB';
  defaultContentBackground = '#FFFFFF';
  spruceDefaultContentBackground = '#CEFDF5';
  errorBackground = '#FFEAEB';
  activeControlBackground = '#F3F4F6';

  // Content
  defaultContentText = '#161616';
  errorText = '#D70006';
  activeControlText = '#FFFFFF';
  contentPlaceholder = '#BBBCBB';

  // Border
  defaultContentBorder = '#E6E7E6';
  errorBorder = '#FF595E';

  // EXTENSIONS
  // Foundation
  primaryVariant = '#4A4D7D';
  tertiaryVariant = '#E2B5ED';
  primaryDisabled = '#E4E5FE';
  tertiaryDisabled = '#F8F7FC';
  primaryOpacity20 = 'rgba(53, 55, 96, 0.2)';
  errorVariant = '#FFACAF';
  primaryDark = '#2D2F52';
  errorDark = '#D70006';
  primaryLightest = '#7A7DB7';
  primaryDarkest = '#222443';
  errorDarkest = '#610202';
  secondaryVariant = '#DBEAF7';
  errorLightest = '#FFEAEB';
  secondaryLightest = '#F6F9FD';
  warningVariant = '#FFC87C';
  secondaryDark = '#0C63B4';
  warningLightest = '#FDF8F3';
  secondaryDarkest = '#002342';
  warningDark = '#95591E';
  purple = '#7C3AED';
  warningDarkest = '#4A2704';
  purpleVariant = '#A78BFA';
  successVariant = '#7FF2B5';
  purpleDarkest = '#4C1D95';
  purple100 = '#EDE9FE';

  // EXTRA
  // Shades of Grey
  white = '#FFFFFF';
  darkGray = '#BBBCBB';
  lightGray = '#F6F7F6';
  black = '#4B4B4B';
  gray = '#E6E7E6';
  gray50 = '#F9FAFB';
  gray100 = '#F3F4F6';
  gray200 = '#E5E7EB';
  gray300 = '#D1D5DB';
  gray400 = '#9CA3AF';
  gray500 = '#6B7280';
  gray600 = '#4B5563';
  gray700 = '#374151';
  gray800 = '#1F2937';
  gray900 = '#111827';
  shadow = '#303133';
  focusHoverShadow = 'rgba(0, 0, 0, 0.05)'; // This color is not a part of Figma theme, but used in Figma
  shadowVariant1 = 'rgba(0, 0, 0, 0.1)';
  shadowVariant2 = 'rgba(0, 0, 0, 0.06)';

  // Colours
  yellow = '#FCD34D';
  blueDark = '#1E40AF';
  yellowVariant = '#FDE68A';
  blueDarkest = '#1E3A8A';
  yellowLightest = '#FFFBEB';
  pink = '#EC4899';
  yellowDark = '#7E6514';
  pinkVariant = '#FBCFE8';
  yellowDarkest = '#78350F';
  pinkLightest = '#FDF2F8';
  blue = '#3B82F6';
  pinkDark = '#9D174D';
  blueVariant = '#93C5FD';
  pinkDarkest = '#831843';
  blueLightest = '#EFF6FF';
  modalCardCurtain = '#F6F7F6';
  green100 = '#D1FAE5';
  green500 = '#10B981';
  blue100 = '#DBEAFE';
  red100 = '#FEE2E2';
  red400 = '#F87171';
  red600 = '#DC2626';
}
